'use strict';

var OCL = require('openchemlib');

require('./extend')(OCL);

module.exports = OCL;